module.exports = __webpack_public_path__ + "img/ic_back.9872d459.svg";